import { render, staticRenderFns } from "./additionalMenu.vue?vue&type=template&id=008f441c&scoped=true&"
import script from "./additionalMenu.vue?vue&type=script&lang=js&"
export * from "./additionalMenu.vue?vue&type=script&lang=js&"
import style0 from "./additionalMenu.vue?vue&type=style&index=0&id=008f441c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008f441c",
  null
  
)

export default component.exports